module.exports = __webpack_public_path__ + "static/media/HeroAkredBg.6b64fc8e.png";